import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { environment } from '../../../environments/environment';

const ADD_CATEGORY_API_URL =
  '/api/v1/quiz/builder/categorie-quiz/addcategorie-quiz';
const GET_CATEGORY_API_URL =
  '/api/v1/quiz/builder/categorie-quiz/getcategorie-quizs';

const DELETE_CATEGORY_API_URL =
  '/api/v1/quiz/builder/categorie-quiz/deletecategorie-quiz/';

const UPDATE_CATEGORY_API_URL =
  '/api/v1/quiz/builder/categorie-quiz/updatecategorie-quiz/';

const BASE_URL = environment.BASE_URL;

@Injectable({
  providedIn: 'root',
})
export class CategoryQuizService {
  constructor(private http: HttpClient, private auth: AuthenticationService) {}

  addCategory(label: string, desc: string) {
    return this.http.post<any>(
      `${BASE_URL}${ADD_CATEGORY_API_URL}`,
      {
        nom: label,
        description: desc,
        statut: 'ACTIF',
      },
      {
        headers: {
          Authorization: `Bearer ${this.auth.currentUserValue.accessToken}`,
        },
      }
    );
  }

  getCategories(
    paginate: boolean = false,
    page: number = 0,
    size: number = 10,
    filters: any = {}
  ): Observable<any> {
    let params = new HttpParams()
      .set('pagination', String(paginate))
      .set('page', String(page))
      .set('size', String(size));

    for (const key in filters) {
      if (filters.hasOwnProperty(key)) {
        params = params.set(key, filters[key]);
      }
    }

    return this.http
      .get<any>(
        `${BASE_URL}${GET_CATEGORY_API_URL}?pagination=${paginate}&page=${page}&size=${size}`,
        {
          headers: {
            Authorization: `Bearer ${this.auth.currentUserValue.accessToken}`,
          },
        }
      )
      .pipe(
        map((categories) => {
          console.log('les categories disponibles', categories);
          return categories;
        })
      );
  }

  deleteCategory(id: number) {
    return this.http.delete<any>(
      `${BASE_URL}${DELETE_CATEGORY_API_URL}${id}`,
      {
        headers: {
          Authorization: `Bearer ${this.auth.currentUserValue.accessToken}`,
        },
      }
    );
  }

  updateCategory(id: number, newData: any) {
    const formData = new FormData();
    const formDataX = {
      nom: newData,
      description: 'Super description',
      statut: 'ACTIF'
    };

    formData.append('categorieQuizsDtoToString', JSON.stringify(formDataX));

    return this.http.put<any>(
      `
    ${BASE_URL}${UPDATE_CATEGORY_API_URL}${id}`,
      formData
    );
  }
}
